var nunjucks = require("exports?nunjucks!nunjucks/browser/nunjucks-slim");
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
var env = new nunjucks.Environment([], { autoescape: true });
var configure = require("/code/nunjucks.config.js")(env);
dependencies["front/components/Video/Video.jinja"] = require( "front/components/Video/Video.jinja" );
dependencies["front/components/Frame/Frame.jinja"] = require( "front/components/Frame/Frame.jinja" );
dependencies["front/components/About/About.jinja"] = require( "front/components/About/About.jinja" );
dependencies["front/components/Footer/Footer.jinja"] = require( "front/components/Footer/Footer.jinja" );




var shim = require("/code/node_modules/nunjucks-loader/runtime-shim");
(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["AboutPage.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/components/Video/Video.jinja", false, "AboutPage.jinja", function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("Video", t_1);
output += "<div class=\"AboutPage\">\n    <div class=\"PageTitle\">\n        <h1 class=\"PageTitle-content u-Heading\">";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "about")),"title")), env.opts.autoescape);
output += "</h1>\n    </div>\n\n    <div class=\"Hero\">\n        ";
env.getTemplate("front/components/Frame/Frame.jinja", false, "AboutPage.jinja", function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
t_4.render(context.getVariables(), frame, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
output += t_5
output += "\n        ";
output += runtime.suppressValue((lineno = 9, colno = 25, runtime.callWrap(runtime.memberLookup((t_1),"Video"), "Video[\"Video\"]", context, ["about_v2",runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "page")),"img")),"main"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "request")),"is_tablet"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_8 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
frame = frame.push();
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
var t_9 = "";;
frame = frame.pop();
return new runtime.SafeString(t_9);
});
return macro_t_8;})()})])), env.opts.autoescape);
output += "\n\n        <button class=\"Hero-btn u-Btn\">\n            ";
output += runtime.suppressValue(env.getFilter("safe").call(context, env.getFilter("require").call(context, "front/components/Hero/Hero-btn.svg")), env.opts.autoescape);
output += "\n        </button>\n    </div>\n\n    ";
env.getTemplate("front/components/About/About.jinja", false, "AboutPage.jinja", function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
t_10.render(context.getVariables(), frame, function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
output += t_11
output += "\n\n    ";
env.getTemplate("front/components/Footer/Footer.jinja", false, "AboutPage.jinja", function(t_16,t_14) {
if(t_16) { cb(t_16); return; }
t_14.render(context.getVariables(), frame, function(t_17,t_15) {
if(t_17) { cb(t_17); return; }
output += t_15
output += "\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

var obj = nunjucks.nunjucksPrecompiled["AboutPage.jinja"]
module.exports = shim(nunjucks, env, obj, dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/AboutPage/AboutPage.jinja
// module id = 101
// module chunks = 0